module.exports = __webpack_public_path__ + "static/media/headerLogo.2937be6c.png";